import { Component, inject, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LoadingController } from "@ionic/angular";
import { EncryptionService } from "src/app/services/encryption.service";
import { LeadsService } from "src/app/services/leads.service";
import { SharedServices } from "src/app/services/shared.service";

@Component({
  selector: "app-dialog-edit-team",
  templateUrl: "./dialog-edit-team.component.html",
  styleUrls: ["./dialog-edit-team.component.scss"],
  standalone: false
})
export class DialogEditTeamComponent implements OnInit {
  selectedOptions: any;
  assignMemberObject: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private leadService: LeadsService,
    private loadingController: LoadingController,
    private encryptionService: EncryptionService,
    private sharedServices: SharedServices
  ) {
    setTimeout(() => {
      if (this.data.type === "Admin") {
        this.data.empList.forEach((element) => {
          if (this.data.data.AdminId === element.Id) {
            element.isSelected = true;
          } else {
            element.isSelected = false;
          }
        });
      } else if (this.data.type === "Manager") {
        this.data.empList.forEach((element) => {
          if (this.data.data.TeamManager === element.Id) {
            element.isSelected = true;
          } else {
            element.isSelected = false;
          }
        });
      } else if (this.data.type === "Leader") {
        this.data.empList.forEach((element) => {
          if (this.data.data.TeamLeader === element.Id) {
            element.isSelected = true;
          } else {
            element.isSelected = false;
          }
        });
      } else if (this.data.type === "Member") {
        if (this.data.data.TeamMembers.length > 0) {
          this.data.data.TeamMembers = this.data.data.TeamMembers.map(Number);

          this.data.empList.forEach((element) => {
            this.data.data.TeamMembers.forEach((elementMember) => {
              if (!element.isSelected) {
                if (element.Id == elementMember) {
                  element.isSelected = true;
                } else {
                  element.isSelected = false;
                }
              }
            });
         
          });
        }
      }

      this.assignMemberObject = {
        TeamName: this.data.data.TeamName,
        TeamDesc: this.data.data.TeamDesc,
        TeamManager: this.data.data.TeamManager,
        TeamLeader: this.data.data.TeamLeader,
        AdminId: this.data.data.AdminId,
        TeamMembers: this.data.data.TeamMembers.join(","),
        MainAgentId: this.sharedServices.getAgentId(),
        Id: this.data.data.Id,
      };
    }, 1000);
  }
  // selectedList(event: any) {
  // }
  async updateMember() {
    if (this.data.type === "Admin") {
      this.assignMemberObject = {
        TeamName: this.data.data.TeamName,
        TeamDesc: this.data.data.TeamDesc,
        TeamManager: this.data.data.TeamManager,
        TeamLeader: this.data.data.TeamLeader,
        AdminId: this.selectedOptions[0],
        TeamMembers: this.data.data.TeamMembers.join(","),
        MainAgentId: parseInt(this.sharedServices.getAgentId()),
        Id: this.data.data.Id,
      };
    } else if (this.data.type === "Manager") {
      this.assignMemberObject = {
        TeamName: this.data.data.TeamName,
        TeamDesc: this.data.data.TeamDesc,
        TeamManager: this.selectedOptions[0],
        TeamLeader: this.data.data.TeamLeader,
        AdminId: this.data.data.AdminId,
        TeamMembers: this.data.data.TeamMembers.join(","),
        MainAgentId: parseInt(this.sharedServices.getAgentId()),
        Id: this.data.data.Id,
      };
    } else if (this.data.type === "Leader") {
      this.assignMemberObject = {
        TeamName: this.data.data.TeamName,
        TeamDesc: this.data.data.TeamDesc,
        TeamManager: this.data.data.TeamManager,
        TeamLeader: this.selectedOptions[0],
        AdminId: this.data.data.AdminId,
        TeamMembers: this.data.data.TeamMembers.join(","),
        MainAgentId: parseInt(this.sharedServices.getAgentId()),
        Id: this.data.data.Id,
      };
    } else if (this.data.type === "Member") {
      this.assignMemberObject = {
        TeamName: this.data.data.TeamName,
        TeamDesc: this.data.data.TeamDesc,
        TeamManager: this.data.data.TeamManager,
        TeamLeader: this.data.data.TeamLeader,
        AdminId: this.data.data.AdminId,
        TeamMembers: this.selectedOptions.join(","),
        MainAgentId: parseInt(this.sharedServices.getAgentId()),
        Id: this.data.data.Id,
      };
    } else {
    }
    const loadingCtrl = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please Wait...",
    });
    await loadingCtrl.present();

    setTimeout(() => {
      this.leadService.UpdateTeam(this.assignMemberObject).subscribe({
        next: async (res) => {
          if (res) {
          }
          // setTimeout(() => {
          // }, 200);
          this.leadService.setTeamChanged(true);
          await loadingCtrl.dismiss();
        },
        error: async (err) => {
          await loadingCtrl.dismiss();
        }
      });
    });
  }
  ngOnInit() {}
}
